import { apiFetch } from "./apiFetch";

export async function createTrialRequest(payload) {
  return apiFetch("/api/requests/trial", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function createTaskBroadcast(payload) {
  return apiFetch("/api/requests/broadcast", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

// ✅ TUTOR inbox (NEW + CHAT_ACTIVE)
export async function listRequestsInbox() {
  const res = await apiFetch("/api/requests/inbox", { method: "GET" });
  return Array.isArray(res?.items) ? res.items : [];
}

// ✅ TUTOR — all requests (full CRM pipeline)
export async function listAllTutorRequests() {
  const res = await apiFetch("/api/requests/tutor", { method: "GET" });
  return Array.isArray(res?.items) ? res.items : [];
}

export async function respondToRequest(requestId) {
  return apiFetch(`/api/requests/${encodeURIComponent(requestId)}/respond`, {
    method: "POST",
  });
}

// ✅ STUDENT requests
export async function listMyRequests() {
  const res = await apiFetch("/api/requests/my", { method: "GET" });
  return Array.isArray(res?.items) ? res.items : [];
}

export async function getRequestById(requestId) {
  return apiFetch(`/api/requests/${encodeURIComponent(requestId)}`, {
    method: "GET",
  });
}

export async function refundRequest(requestId) {
  return apiFetch(`/api/requests/${encodeURIComponent(requestId)}/refund`, {
    method: "POST",
  });
}

export async function setRequestOutcome(requestId, status) {
  return apiFetch(`/api/requests/${encodeURIComponent(requestId)}/outcome`, {
    method: "POST",
    body: JSON.stringify({ status }),
  });
}

export async function fileDispute(requestId) {
  return apiFetch(`/api/requests/${encodeURIComponent(requestId)}/dispute`, {
    method: "POST",
  });
}

export async function cancelRequest(requestId) {
  return apiFetch(`/api/requests/${encodeURIComponent(requestId)}/cancel`, {
    method: "POST",
  });
}
